import { useForm } from 'react-hook-form';
import {
  AddOfficeFormValues,
  addOfficeFormResolver,
  EditOfficeFormValues,
  editOfficeFormResolver,
} from './schema';

export type AddOfficeUseForm = ReturnType<typeof useForm<AddOfficeFormValues>>;
export type EditOfficeUseForm = ReturnType<
  typeof useForm<EditOfficeFormValues>
>;

export const useAddOfficeForm = (
  defaultValues?: Partial<AddOfficeFormValues>,
) => {
  const addOfficeForm = useForm<AddOfficeFormValues>({
    resolver: addOfficeFormResolver,
    defaultValues: {
      name: '',
      siteId: '',
      estimatedCaPerSlot: 0,
      averageSlotHonorary: 0,
      withAssistantRetrocessionRate: 0.7,
      withoutAssistantRetrocessionRate: 0.77,
      weekendRetrocessionRate: 0.7,
      ...defaultValues,
      address: {
        city: '',
        line1: '',
        line2: '',
        postalCode: '',
        ...defaultValues?.address,
      },
    },
    // mode: 'all',
  });

  return { addOfficeForm };
};

export const useEditOfficeForm = (
  defaultValues?: Partial<EditOfficeFormValues>,
) => {
  const editOfficeForm = useForm<EditOfficeFormValues>({
    resolver: editOfficeFormResolver,
    defaultValues: {
      name: '',
      estimatedCaPerSlot: 0,
      averageSlotHonorary: 0,
      withAssistantRetrocessionRate: 0.7,
      withoutAssistantRetrocessionRate: 0.77,
      weekendRetrocessionRate: 0.7,
      ...defaultValues,
      address: {
        city: '',
        line1: '',
        line2: '',
        postalCode: '',
        ...defaultValues?.address,
      },
    },
  });

  return { editOfficeForm };
};
